/**
 * @typedef {Object} MenuItem
 * @property {number} id
 * @property {Array<MenuItem>} [children]
 */

/**
 * Retrieves the IDs of the deepest elements in the menu (those without children).
 * @param {Object} menu
 * @returns {Array<number>}
 */
export function getPagesIdsFromMenu(menu) {
  const pagesIds = [];

  function traverse(items) {
    items.forEach((item) => {
      const isLeaf = item.children.length === 0;

      if (isLeaf && item.object?.id) {
        pagesIds.push(item.object.id);
      } else if (item.children && item.children.length > 0) {
        traverse(item.children);
      }
    });
  }

  if (menu?.items) {
    traverse(menu.items);
  }
  return pagesIds;
}
